<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 0
    },
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: 100
    },
    defaultValue: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 20
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },
  computed: {
    sliderDefaultValue() {
      return this.value;
    },
    IsNullOrEmptyErrorMessage() {
      if (this.required && !IsNullOrEmpty(this.value)) {
        return true;
      }
    }
  },
  mounted() {
    // console.log(this.$refs)
    this.$refs.sliderInput.$on("range:change", payload => {
      this.sliderChange(payload);
    });
  },
  methods: {
    sliderChange(payload) {
      console.log("sliderChange", payload);
      this.$emit("propChange", {
        value: payload
      });
    }
  }
};
</script>
<template>
    <f7-list class="list inputs-list">
        <f7-list-item>
            <f7-label :inline="true">Range </f7-label>
            <f7-range ref="sliderInput" type="range" min="0" max="100" step="1" :value="sliderDefaultValue"></f7-range>
              <!-- <span v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</span> -->
              <div v-if="errorMessage" class="color-red">{{errorMessage}}</div>
        </f7-list-item>

    </f7-list>
</template>
<style scoped>
.list li {
  /* background-color: #ffffff; */
}
.list {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/SliderInput.vue